import React, {Suspense} from "react";
import {Redirect, Switch} from "react-router-dom";
import {ContentRoute, LayoutSplashScreen} from "../../_metronic/layout";
import {DashboardPage} from "../customer/dashboard/DashboardPage";
import OrderEditIndex from "../customer/orders/order-edit";
import Orders from "../customer/orders";
import Baskets from "../customer/baskets";
import Products from "../customer/products";
import ProductEditIndex from "../customer/products/product-edit";


export default function CustomerPages() {
    // useEffect(() => {
    //   console.log('Base page');
    // }, []) // [] - is required if you need only one call
    // https://reactjs.org/docs/hooks-reference.html#useeffect

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/customer/dashboard"/>
                }
                <ContentRoute path="/customer/dashboard" component={DashboardPage}/>
                <ContentRoute path="/customer/orders/:id" component={OrderEditIndex}/>
                <ContentRoute path="/customer/orders" component={Orders}/>
                <ContentRoute path="/customer/baskets" component={Baskets}/>
                <ContentRoute path="/customer/products/:id" component={ProductEditIndex}/>
                <ContentRoute path="/customer/products" component={Products}/>
                <Redirect to="error/error-v1"/>
            </Switch>
        </Suspense>
    );
}
